// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateOrganizationBinding, CreateOrganizationBindingSchema } from 'api/gen/CreateOrganizationBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOrganizationBindingAdminBaseObject, ValidateOrganizationBindingAdminBaseObjectSchema } from 'api/gen/ValidateOrganizationBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateOrganizationBindingAdmin'),
  binding: t.union([CreateOrganizationBindingSchema, t.null]),
});

export const ValidateCreateOrganizationBindingAdminSchema = excess(t.intersection([ValidateOrganizationBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateOrganizationBindingAdmin extends t.TypeOf<typeof ValidateCreateOrganizationBindingAdminSchema> {}
